import React from 'react';
import { motion } from 'framer-motion';
import RevealText from '../atoms/RevealText';
import { HERO_VIDEO } from '../../data';

const HeroSection = () => {
    return (
        <section id="home" className="relative min-h-[100dvh] flex flex-col justify-center pb-20 px-6 md:px-12 overflow-hidden">
            <div className="absolute inset-0 z-0">
                <motion.div
                    initial={{ scale: 1.2 }}
                    animate={{ scale: 1 }}
                    transition={{ duration: 2, ease: "easeOut" }}
                    className="w-full h-full"
                >
                    <video src={HERO_VIDEO} autoPlay muted loop playsInline className="w-full h-full object-cover opacity-60" />
                </motion.div>
                <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/20 to-transparent"></div>
            </div>

            <div className="relative z-10 max-w-[90vw]">
                <h1 className="font-migra text-[11vw] leading-none mix-blend-overlay opacity-90 tracking-tight">
                    <RevealText className="pb-[2vw]">Strategic</RevealText>
                    <RevealText className="pl-[8vw] italic pb-[2vw]">Web Developer</RevealText>
                </h1>
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 1.8, duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
                    className="mt-12 flex flex-col md:flex-row justify-between items-end border-t border-white/20 pt-6"
                >
                    <p className="text-sm md:text-base max-w-md opacity-80 font-light">
                        I partner with high-stakes founders to build digital ecosystems that command market share. Direct accountability. Zero agency bloat.
                    </p>
                    <span className="block text-xs uppercase tracking-[0.2em] animate-pulse mt-8 md:mt-0 opacity-60">Scroll to discover</span>
                </motion.div>
            </div>
        </section>
    );
};

export default HeroSection;
